import React from "react";

type Props = {
  start: string | number;
  end?: string | number;
  className?: string;
  dateClassName?: string;
  timeClassName?: string;
};

function formatDate(date: Date) {
  return date.toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
}

function formatTime(date: Date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  return minutes === 0
    ? `${hours}${ampm}`
    : `${hours}:${minutes.toString().padStart(2, "0")}${ampm}`;
}

export default function EventDateTimeDisplay({ start, end, className, dateClassName, timeClassName }: Props) {
  const startDate = new Date(typeof start === "string" ? parseInt(start) : start);
  const endDate = end ? new Date(typeof end === "string" ? parseInt(end) : end) : null;

  let showSecondDay = false;
  if (endDate) {
    const nextDay = new Date(startDate);
    nextDay.setDate(startDate.getDate() + 1);
    nextDay.setHours(5, 1, 0, 0);
    showSecondDay = endDate < nextDay;
  }

  if (!endDate) {
    return (
      <div className={className}>
        <div className={`uppercase font-bold text-4xl ${dateClassName}`}>{formatDate(startDate)}</div>
        <div className={`opacity-50 text-3xl ${timeClassName}`}>{formatTime(startDate)}</div>
      </div>
    );
  }

  if (showSecondDay) {
    return (
      <div className={'flex flex-col ' + className}>
        <span className={`uppercase font-bold text-4xl ${dateClassName}`}>{formatDate(startDate)}</span>
        <span className={`opacity-50 text-3xl ${timeClassName}`}>
          {formatTime(startDate)}-{formatTime(endDate)}
        </span>
      </div>
    );
  }

  return (
    <div className={className}>
      <div>
        <span className={`uppercase font-bold text-4xl ${dateClassName}`}>{formatDate(startDate)}</span>
        <span className={`opacity-50 text-3xl ml-2 ${timeClassName}`}>{formatTime(startDate)}</span>
      </div>
      <div>
        <span className={`uppercase font-bold text-4xl ${dateClassName}`}>TO {formatDate(endDate)}</span>
        <span className={`opacity-50 text-3xl ml-2 ${timeClassName}`}>{formatTime(endDate)}</span>
      </div>
    </div>
  );
}